import { render, staticRenderFns } from "./st-related.vue?vue&type=template&id=e73f75a6&"
import script from "./st-related.vue?vue&type=script&lang=js&"
export * from "./st-related.vue?vue&type=script&lang=js&"
import style0 from "./st-related.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports